import React from 'react';
import { Bug, HelpCircle, Mail } from 'lucide-react';

interface ChatWelcomeProps {
  userName?: string;
  onTopicClick: (topic: string) => void;
}

const topics = [
  { icon: Bug, label: 'Что-то не работает', message: 'Что-то не работает' },
  { icon: HelpCircle, label: 'Не понимаю как сделать', message: 'Не понимаю как сделать' },
  { icon: Mail, label: 'Другой вопрос', message: 'У меня другой вопрос' },
];

const ChatWelcome: React.FC<ChatWelcomeProps> = ({ userName, onTopicClick }) => {
  return (
    <div className="flex flex-col-dir items-center justify-center flex-1 gap-5" style={{ padding: 'var(--space-8) var(--space-6)' }}>
      {/* Avatar */}
      <div className="rounded-full flex items-center justify-center flex-shrink-0" style={{ width: 48, height: 48, background: 'var(--primary-600)', color: 'var(--surface-1, white)', fontSize: '24px' }}>
        ✦
      </div>

      <div className="text-center">
        <h3 className="m-0 font-semibold text-gray-900" style={{ fontSize: 'var(--text-xl)' }}>
          AI Помощник
        </h3>
        <p className="text-sm text-gray-600" style={{ margin: 'var(--space-2) 0 0' }}>
          {userName
            ? `Привет, ${userName}! Опишите проблему — я помогу разобраться`
            : 'Опишите проблему — я помогу разобраться'}
        </p>
      </div>

      {/* Topic cards */}
      <div className="flex flex-col-dir gap-2 w-full" style={{ maxWidth: 280 }}>
        {topics.map(({ icon: Icon, label, message }) => (
          <button
            key={label}
            type="button"
            onClick={() => onTopicClick(message)}
            className="flex items-center gap-3 bg-gray-50 border-gray-200 rounded-lg cursor-pointer text-sm font-medium text-gray-700 w-full" style={{ padding: 'var(--space-3) var(--space-4)', transition: 'all 0.15s', textAlign: 'left' as const, fontFamily: 'inherit', minHeight: 48 }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.background = 'var(--primary-50)';
              (e.currentTarget as HTMLElement).style.borderColor = 'var(--primary-200)';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.background = 'var(--gray-50)';
              (e.currentTarget as HTMLElement).style.borderColor = 'var(--gray-200)';
            }}
          >
            <Icon size={16} className="flex-shrink-0 text-gray-500" />
            {label}
          </button>
        ))}
      </div>

      <p className="text-xs text-gray-500 m-0">
        Или просто напишите ↓
      </p>
    </div>
  );
};

export default ChatWelcome;
